"use strict";Object.defineProperty(exports, "__esModule", {value: true});var LoginMethod; (function (LoginMethod) { const QUICK = 1; LoginMethod[LoginMethod["QUICK"] = QUICK] = "QUICK"; const USERNAME = QUICK + 1; LoginMethod[LoginMethod["USERNAME"] = USERNAME] = "USERNAME"; })(LoginMethod || (exports.LoginMethod = LoginMethod = {}));



// /login?tab=patient opens the Patient side (sign-up's "Patient sign-in").
 const LOGIN_TAB_PARAM = 'tab'; exports.LOGIN_TAB_PARAM = LOGIN_TAB_PARAM

// 'no-email': the account has no verified email, so no reset email was sent.


// /login/expired-password?reason=no-email shows the 'no-email' notice.
 const EXPIRED_PASSWORD_REASON_PARAM = 'reason'; exports.EXPIRED_PASSWORD_REASON_PARAM = EXPIRED_PASSWORD_REASON_PARAM
